var React = require('react');

var Input = require('../input');
var Button = require('../button');

var css = require('./module.scss');

var Form = React.createClass({

    onPageChange: function(e) {
        var pageObj = this.refs.form.page;
        var page = pageObj.value;

        e.preventDefault();
        if (!page || !/^\d+$/.test(page)) {
            pageObj.focus();

            return;
        }
        if (page < this.props.min) {
            page = this.props.min;
        } else if (page > this.props.max) {
            page = this.props.max;
        }

        this.props.onPageChange(page);
        pageObj.value = '';
    },

    render: function() {
        var cls = ['fp-page-form'];
        if (this.props.btnSize) {
            cls.push('fp-page-' + this.props.btnSize);
        }
        return (
            <form
                ref="form"
                className={ cls.join(' ') }
                onSubmit={ this.onPageChange }
            >
                <fieldset>
                    <span>跳至</span>
                    <Input
                        name="page"
                        autoComplete="off"
                        size={this.props.btnSize || ''}
                    />
                    <span>页&nbsp;/&nbsp;共&nbsp;{ this.props.max }&nbsp;页&nbsp;共&nbsp;{this.props.total}&nbsp;条记录</span>
                    {/* <Button
                        type="submit"
                        style="default"
                        text="确定"
                        size={this.props.btnSize || ''}
                    /> */}
                </fieldset>
            </form>
        );
    }

});

module.exports = Form;



// WEBPACK FOOTER //
// ./component/pagination/form.js